import { dispatch } from 'pluginServices/store';
import { pushToast } from 'containers/ToastManager/actions';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

export const pushPreflightToast = (message, title, id, exportId, unsubscribeExportAndResetSnippets) => {
  dispatch(pushToast({
    message: intl.formatMessage(message),
    subtitle: title,
    actions: [
      {
        text: 'CANCEL',
        fn: () => {
          unsubscribeExportAndResetSnippets(exportId);
        },
      },
    ],
    toastId: id,
    type: 'sticky',
    waitForAction: true,
  }));
};

export default pushPreflightToast;